import { render } from "./index.vue?vue&type=template&id=52f29647&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Pages/Admin/PlayerComplaints/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52f29647"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52f29647', __exports__)) {
    api.reload('52f29647', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=52f29647&ts=true", () => {
    api.rerender('52f29647', render)
  })

}


export default __exports__